/* eslint-disable @typescript-eslint/no-explicit-any */ import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @public */ export const localizationTranslationProviderIdValidator = idValidator("localization_provider");
/** @public */ export function createLocalizationTranslationProviderValidator(type, props, meta) {
    return T.object({
        id: localizationTranslationProviderIdValidator,
        typeName: T.literal("localization_provider"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue
    });
}
